const ErbHome = {
  cleanups: new Map(),

  boot(root) {
    if (!root || root.dataset.erbInit === 'true') return;

    root.dataset.erbInit = 'true';
    const cleanups = [];

    if (root.hasAttribute('data-erb-hero')) cleanups.push(this.initHero(root));
    if (root.hasAttribute('data-erb-announce')) cleanups.push(this.initAnnounce(root));
    if (root.hasAttribute('data-erb-pantry')) cleanups.push(this.initPantry(root));
    if (root.hasAttribute('data-erb-rail')) cleanups.push(this.initRail(root));
    if (root.hasAttribute('data-erb-concerns')) cleanups.push(this.initConcerns(root));
    if (root.hasAttribute('data-erb-trust')) cleanups.push(this.initTrust(root));
    if (root.hasAttribute('data-erb-promises')) cleanups.push(this.initPromises(root));
    if (root.hasAttribute('data-erb-plans')) cleanups.push(this.initPlans(root));
    if (root.hasAttribute('data-erb-collection-header')) cleanups.push(this.initCollectionHeader(root));

    this.cleanups.set(root, cleanups.filter(Boolean));
  },

  destroy(root) {
    const cleanups = this.cleanups.get(root) || [];

    cleanups.forEach((cleanup) => cleanup());
    this.cleanups.delete(root);

    if (root) delete root.dataset.erbInit;
  },

  chrome() {
    if (document.documentElement.dataset.erbChrome === 'true') return;

    document.documentElement.dataset.erbChrome = 'true';

    document.querySelector('[data-erb-open-cart]')?.addEventListener('click', () => {
      document.querySelector('.js-mini-cart .js-toggle-cart')?.click();
    });

    document.addEventListener('click', (event) => {
      const basket = event.target.closest('.erb-header__basket');
      if (basket && !event.target.closest('.js-toggle-cart') && !event.target.closest('.mini-cart-content')) {
        basket.querySelector('.js-toggle-cart')?.click();
      }
    });

    document.addEventListener('click', (event) => {
      const option = event.target.closest('.erb-tile__option');

      if (!option) return;

      const tile = option.closest('.erb-tile');
      const button = tile?.querySelector('.erb-tile__add');

      if (!tile || !button) return;

      for (const item of tile.querySelectorAll('.erb-tile__option')) {
        const selected = item === option;

        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      }

      button.disabled = false;
      button.setAttribute('data-id', option.dataset.id || '');
      window.jQuery?.(button).data('id', option.dataset.id || '');

      const price = tile.querySelector('[data-erb-price]');

      if (price) {
        const rawPrice = option.dataset.price || price.dataset.initial || '';
        price.textContent = rawPrice.replace(/Rs\.?\s*/g, '₹');
      }

      const compare = tile.querySelector('[data-erb-compare]');

      if (compare) {
        compare.hidden = !option.dataset.compare;
        compare.textContent = (option.dataset.compare || '').replace(/Rs\.?\s*/g, '₹');
      }

      const badge = tile.querySelector('[data-erb-badge]');

      if (badge) {
        badge.hidden = !option.dataset.percent;
        badge.textContent = option.dataset.percent || '';
      }

      const circlePrice = tile.querySelector('[data-erb-circle-price]');
      if (circlePrice) {
        if (option.dataset.circlePrice) {
          circlePrice.textContent = option.dataset.circlePrice;
        } else if (option.dataset.priceCents) {
          const cents = parseInt(option.dataset.priceCents, 10);
          if (cents > 0) {
            const circleRupees = Math.floor((cents * 0.99) / 100);
            circlePrice.textContent = `ERB Circle: ₹${circleRupees.toLocaleString('en-IN')}`;
          }
        }
      }

      const circleBack = tile.querySelector('[data-erb-circle-back]');
      if (circleBack) {
        if (option.dataset.circleBack) {
          circleBack.textContent = option.dataset.circleBack;
        } else if (option.dataset.priceCents) {
          const cents = parseInt(option.dataset.priceCents, 10);
          if (cents > 0) {
            const backRupees = Math.max(1, Math.round((cents * 0.03) / 100));
            circleBack.textContent = `+ ₹${backRupees.toLocaleString('en-IN')} Discount`;
          }
        }
      }
    });
  },

  prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  },

  initHero(root) {
    const viewport = root.querySelector('[data-erb-viewport]');
    const track = root.querySelector('[data-erb-track]');
    const slides = [...root.querySelectorAll('[data-erb-slide]')];
    const dots = [...root.querySelectorAll('[data-erb-dot]')];
    const dotsWrap = root.querySelector('[data-erb-dots]');
    const bar = root.querySelector('[data-erb-dot-bar]');
    const status = root.querySelector('[data-erb-status]');

    if (!viewport || !track || slides.length < 2) return null;

    let index = 0;
    let timer = 0;
    let paused = false;
    let suppressClick = false;
    let drag = null;
    const delay = Number(root.dataset.erbAutoplay || 0);

    const placeBar = (animate) => {
      if (!bar || !dotsWrap || !dots[index]) return;

      const dot = dots[index];
      const left = dot.offsetLeft + (dot.offsetWidth - bar.offsetWidth) / 2;

      bar.style.transition = animate ? '' : 'none';
      bar.style.transform = `translate(${left}px, -50%)`;

      if (!animate) {
        bar.getBoundingClientRect();
        bar.style.transition = '';
      }
    };

    const moveTrack = (offset, animate) => {
      const x = (-index * viewport.clientWidth) + offset;

      track.classList.toggle('is-animating', animate && !this.prefersReducedMotion());
      track.style.transform = `translate3d(${x}px, 0, 0)`;
    };

    const show = (next, animate) => {
      index = (next + slides.length) % slides.length;

      slides.forEach((slide, slideIndex) => {
        const selected = slideIndex === index;

        slide.toggleAttribute('inert', !selected);
        slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
      });

      dots.forEach((dot, dotIndex) => {
        dot.setAttribute('aria-selected', dotIndex === index ? 'true' : 'false');
      });

      if (status) {
        status.textContent = (status.dataset.template || '')
          .replace('__i__', String(index + 1))
          .replace('__n__', String(slides.length));
      }

      moveTrack(0, animate);
      placeBar(animate);
    };

    const stop = () => window.clearInterval(timer);

    const start = () => {
      stop();
      if (paused || drag || this.prefersReducedMotion() || delay < 1) return;
      timer = window.setInterval(() => show(index + 1, true), delay);
    };

    const pause = () => {
      paused = true;
      stop();
    };

    const resume = (event) => {
      if (drag) return;
      if (event.relatedTarget && root.contains(event.relatedTarget)) return;
      paused = false;
      start();
    };

    const onClick = (event) => {
      const prev = event.target.closest('[data-erb-prev]');
      const next = event.target.closest('[data-erb-next]');
      const dot = event.target.closest('[data-erb-dot]');

      if ((!prev && !next && !dot) || !root.contains(prev || next || dot)) return;

      if (prev) show(index - 1, true);
      if (next) show(index + 1, true);
      if (dot) show(Number(dot.dataset.erbDot), true);
      start();
    };

    const endDrag = (event) => {
      if (!drag || event.pointerId !== drag.id) return;

      const dx = event.clientX - drag.x;
      const moved = drag.moved;

      drag = null;
      viewport.classList.remove('is-dragging');

      if (moved) suppressClick = true;

      if (moved && Math.abs(dx) > 48) {
        show(index + (dx < 0 ? 1 : -1), true);
      } else {
        moveTrack(0, moved);
      }

      window.setTimeout(() => {
        suppressClick = false;
      }, 400);

      if (!viewport.matches(':hover') && !root.matches(':hover')) paused = false;
      start();
    };

    const onPointerDown = (event) => {
      if (event.button !== 0) return;
      if (event.target.closest('.erb-hero__btn')) return;

      drag = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY,
        moved: false,
      };
      viewport.classList.add('is-dragging');
      track.classList.remove('is-animating');

      try {
        viewport.setPointerCapture(event.pointerId);
      } catch (error) {
        // Pointer capture is unavailable until the browser sees a real pointer.
      }

      pause();
    };

    const onPointerMove = (event) => {
      if (!drag || event.pointerId !== drag.id) return;

      const dx = event.clientX - drag.x;
      const dy = event.clientY - drag.y;

      if (!drag.moved && Math.abs(dx) < 8 && Math.abs(dy) < 8) return;

      if (!drag.moved && Math.abs(dy) > Math.abs(dx)) {
        drag = null;
        viewport.classList.remove('is-dragging');
        if (!viewport.matches(':hover') && !root.matches(':hover')) paused = false;
        start();
        return;
      }

      drag.moved = true;
      moveTrack(dx, false);
    };

    const onDragClick = (event) => {
      if (!suppressClick) return;

      event.preventDefault();
      event.stopPropagation();
    };

    const onDragStart = (event) => {
      event.preventDefault();
    };

    const onResize = () => {
      moveTrack(0, false);
      placeBar(false);
    };

    root.addEventListener('click', onClick);
    viewport.addEventListener('click', onDragClick, true);
    viewport.addEventListener('dragstart', onDragStart);
    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointermove', onPointerMove);
    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    root.addEventListener('pointerenter', pause);
    root.addEventListener('pointerleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', resume);
    window.addEventListener('resize', onResize);
    dotsWrap?.classList.add('is-ready');
    show(0, false);
    start();

    return () => {
      stop();
      root.removeEventListener('click', onClick);
      viewport.removeEventListener('click', onDragClick, true);
      viewport.removeEventListener('dragstart', onDragStart);
      viewport.removeEventListener('pointerdown', onPointerDown);
      viewport.removeEventListener('pointermove', onPointerMove);
      viewport.removeEventListener('pointerup', endDrag);
      viewport.removeEventListener('pointercancel', endDrag);
      root.removeEventListener('pointerenter', pause);
      root.removeEventListener('pointerleave', resume);
      root.removeEventListener('focusin', pause);
      root.removeEventListener('focusout', resume);
      window.removeEventListener('resize', onResize);
    };
  },

  initAnnounce(root) {
    const messages = [...root.querySelectorAll('.erb-announce__msg')];

    if (messages.length < 2 || this.prefersReducedMotion()) return null;

    let index = 0;
    const delay = Number(root.dataset.erbAutoplay || 4000);
    const timer = window.setInterval(() => {
      messages[index].classList.remove('is-on');
      index = (index + 1) % messages.length;
      messages[index].classList.add('is-on');
    }, delay);

    return () => window.clearInterval(timer);
  },

  initPantry(root) {
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const panels = [...root.querySelectorAll('[role="tabpanel"]')];
    const stages = [...root.querySelectorAll('[data-erb-pantry-stage]')];

    const syncStage = (stage) => {
      const rail = stage.querySelector('.erb-rail');
      const next = stage.querySelector('[data-erb-pantry-next]');
      const prev = stage.querySelector('[data-erb-pantry-prev]');
      if (!rail || !next) return;
      if (stage.closest('[hidden]')) return;

      const maxScroll = rail.scrollWidth - rail.clientWidth;
      const canScroll = maxScroll > 8;

      if (prev) prev.hidden = !canScroll;
      next.hidden = !canScroll || rail.scrollLeft >= maxScroll - 8;
    };

    const syncStages = () => {
      stages.forEach(syncStage);
    };

    const select = (tab) => {
      const id = tab.getAttribute('aria-controls');

      tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
        item.tabIndex = selected ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.id !== id;
      });

      window.requestAnimationFrame(syncStages);
    };

    const onClick = (event) => {
      const control = event.target.closest('[data-erb-pantry-next], [data-erb-pantry-prev]');

      if (control && root.contains(control)) {
        const stage = control.closest('[data-erb-pantry-stage]');
        const rail = stage?.querySelector('.erb-rail');
        const tile = rail?.querySelector('.erb-tile');
        if (!rail || !tile) return;

        const gap = Number.parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 0;
        const amount = tile.getBoundingClientRect().width + gap;
        const direction = control.hasAttribute('data-erb-pantry-prev') ? -1 : 1;

        rail.scrollBy({
          left: amount * direction,
          behavior: this.prefersReducedMotion() ? 'auto' : 'smooth',
        });
        return;
      }

      const tab = event.target.closest('[role="tab"]');
      if (!tab || !root.contains(tab)) return;
      select(tab);
    };

    const onKeydown = (event) => {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

      const current = tabs.indexOf(document.activeElement);
      if (current < 0) return;

      event.preventDefault();
      const nextIndex = event.key === 'ArrowRight'
        ? (current + 1) % tabs.length
        : (current - 1 + tabs.length) % tabs.length;

      tabs[nextIndex].focus();
      select(tabs[nextIndex]);
    };

    const onScroll = (event) => {
      const stage = event.target.closest?.('[data-erb-pantry-stage]');
      if (!stage || !root.contains(stage)) return;
      syncStage(stage);
    };

    root.addEventListener('click', onClick);
    root.addEventListener('keydown', onKeydown);
    root.addEventListener('scroll', onScroll, true);
    window.addEventListener('resize', syncStages);
    syncStages();

    return () => {
      root.removeEventListener('click', onClick);
      root.removeEventListener('keydown', onKeydown);
      root.removeEventListener('scroll', onScroll, true);
      window.removeEventListener('resize', syncStages);
    };
  },

  initRail(root) {
    const stage = root.querySelector('[data-erb-rail-stage]');
    const rail = stage?.querySelector('.erb-rail');
    const prev = stage?.querySelector('[data-erb-rail-prev]');
    const next = stage?.querySelector('[data-erb-rail-next]');

    if (!stage || !rail) return null;

    const sync = () => {
      const maxScroll = rail.scrollWidth - rail.clientWidth;
      const atStart = rail.scrollLeft <= 8;
      const atEnd = rail.scrollLeft >= maxScroll - 8;

      if (prev) prev.hidden = maxScroll <= 8 || atStart;
      if (next) next.hidden = maxScroll <= 8 || atEnd;
    };

    const scrollByCard = (direction) => {
      const tile = rail.querySelector('.erb-tile');
      if (!tile) return;

      const gap = Number.parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 0;
      const amount = tile.getBoundingClientRect().width + gap;

      rail.scrollBy({
        left: amount * direction,
        behavior: this.prefersReducedMotion() ? 'auto' : 'smooth',
      });
    };

    const onClick = (event) => {
      if (event.target.closest('[data-erb-rail-prev]')) scrollByCard(-1);
      if (event.target.closest('[data-erb-rail-next]')) scrollByCard(1);
    };

    stage.addEventListener('click', onClick);
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();

    return () => {
      stage.removeEventListener('click', onClick);
      rail.removeEventListener('scroll', sync);
      window.removeEventListener('resize', sync);
    };
  },

  initConcerns(root) {
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const panels = [...root.querySelectorAll('[role="tabpanel"]')];
    const tablist = root.querySelector('.erb-concerns__tabs') || root.querySelector('[role="tablist"]');
    const stages = [...root.querySelectorAll('[data-erb-concerns-stage], [data-erb-pantry-stage]')];

    const syncStage = (stage) => {
      const rail = stage.querySelector('.erb-rail');
      const next = stage.querySelector('[data-erb-concerns-next], [data-erb-pantry-next]');
      const prev = stage.querySelector('[data-erb-concerns-prev], [data-erb-pantry-prev]');
      if (!rail || !next) return;
      if (stage.closest('[hidden]')) return;

      const maxScroll = rail.scrollWidth - rail.clientWidth;
      const canScroll = maxScroll > 8;

      if (prev) prev.hidden = !canScroll || rail.scrollLeft <= 8;
      next.hidden = !canScroll || rail.scrollLeft >= maxScroll - 8;
    };

    const syncStages = () => {
      stages.forEach(syncStage);
    };

    const select = (tab) => {
      const id = tab.getAttribute('aria-controls');

      tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
        item.tabIndex = selected ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.id !== id;
      });

      window.requestAnimationFrame(syncStages);
    };

    let hasDragged = false;

    const onClick = (event) => {
      const control = event.target.closest('[data-erb-concerns-next], [data-erb-concerns-prev], [data-erb-pantry-next], [data-erb-pantry-prev]');

      if (control && root.contains(control)) {
        const stage = control.closest('[data-erb-concerns-stage], [data-erb-pantry-stage]');
        const rail = stage?.querySelector('.erb-rail');
        const tile = rail?.querySelector('.erb-tile');
        if (!rail || !tile) return;

        const gap = Number.parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 0;
        const amount = tile.getBoundingClientRect().width + gap;
        const direction = control.hasAttribute('data-erb-concerns-prev') || control.hasAttribute('data-erb-pantry-prev') ? -1 : 1;

        rail.scrollBy({
          left: amount * direction,
          behavior: this.prefersReducedMotion() ? 'auto' : 'smooth',
        });
        return;
      }

      if (hasDragged) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      const tab = event.target.closest('[role="tab"]');
      if (!tab || !root.contains(tab)) return;
      select(tab);
      if (typeof tab.scrollIntoView === 'function') {
        tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    };

    const onKeydown = (event) => {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

      const current = tabs.indexOf(document.activeElement);
      if (current < 0) return;

      event.preventDefault();
      const nextIndex = event.key === 'ArrowRight'
        ? (current + 1) % tabs.length
        : (current - 1 + tabs.length) % tabs.length;

      tabs[nextIndex].focus();
      select(tabs[nextIndex]);
      if (typeof tabs[nextIndex].scrollIntoView === 'function') {
        tabs[nextIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    };

    const onRailScroll = (event) => {
      const stage = event.target.closest('[data-erb-concerns-stage], [data-erb-pantry-stage]');
      if (stage) syncStage(stage);
    };

    root.addEventListener('click', onClick);
    root.addEventListener('keydown', onKeydown);
    root.addEventListener('scroll', onRailScroll, true);
    window.addEventListener('resize', syncStages);
    syncStages();

    let cleanupDrag = () => {};

    if (tablist) {
      let isDown = false;
      let startX = 0;
      let scrollStart = 0;

      const checkOverflow = () => {
        tablist.classList.toggle('is-overflowing', tablist.scrollWidth > tablist.clientWidth + 2);
      };

      checkOverflow();
      window.addEventListener('resize', checkOverflow);

      const onMouseDown = (e) => {
        if (e.button !== 0) return;
        isDown = true;
        hasDragged = false;
        startX = e.pageX - tablist.offsetLeft;
        scrollStart = tablist.scrollLeft;
        tablist.classList.add('is-dragging');
        tablist.style.scrollBehavior = 'auto';
      };

      const onMouseMove = (e) => {
        if (!isDown) return;
        const x = e.pageX - tablist.offsetLeft;
        const walk = x - startX;
        if (Math.abs(walk) > 4) {
          hasDragged = true;
        }
        tablist.scrollLeft = scrollStart - walk;
      };

      const endDrag = () => {
        if (!isDown) return;
        isDown = false;
        tablist.classList.remove('is-dragging');
        tablist.style.removeProperty('scroll-behavior');
        if (hasDragged) {
          setTimeout(() => {
            hasDragged = false;
          }, 80);
        }
      };

      const onCaptureClick = (e) => {
        if (hasDragged) {
          e.preventDefault();
          e.stopPropagation();
        }
      };

      tablist.addEventListener('mousedown', onMouseDown);
      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', endDrag);
      tablist.addEventListener('click', onCaptureClick, true);

      let touchStartX = 0;
      let touchMoved = false;

      const onTouchStart = (e) => {
        if (e.touches.length === 1) {
          touchStartX = e.touches[0].pageX;
          touchMoved = false;
        }
      };

      const onTouchMove = (e) => {
        if (e.touches.length === 1) {
          if (Math.abs(e.touches[0].pageX - touchStartX) > 6) {
            touchMoved = true;
          }
        }
      };

      const onTouchEnd = () => {
        if (touchMoved) {
          hasDragged = true;
          setTimeout(() => {
            hasDragged = false;
            touchMoved = false;
          }, 80);
        }
      };

      tablist.addEventListener('touchstart', onTouchStart, { passive: true });
      tablist.addEventListener('touchmove', onTouchMove, { passive: true });
      tablist.addEventListener('touchend', onTouchEnd, { passive: true });

      cleanupDrag = () => {
        window.removeEventListener('resize', checkOverflow);
        tablist.removeEventListener('mousedown', onMouseDown);
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', endDrag);
        tablist.removeEventListener('click', onCaptureClick, true);
        tablist.removeEventListener('touchstart', onTouchStart);
        tablist.removeEventListener('touchmove', onTouchMove);
        tablist.removeEventListener('touchend', onTouchEnd);
      };
    }

    return () => {
      root.removeEventListener('click', onClick);
      root.removeEventListener('keydown', onKeydown);
      root.removeEventListener('scroll', onRailScroll, true);
      window.removeEventListener('resize', syncStages);
      cleanupDrag();
    };
  },

  initTrust(root) {
    const list = root.querySelector('[data-erb-trust-list]');
    const dots = root.querySelector('[data-erb-trust-dots]');

    if (!list) return null;

    const mobile = window.matchMedia('(max-width: 749px)');
    const canHover = window.matchMedia('(hover: hover)').matches;
    const delay = 3200;
    let page = 0;
    let timer = 0;
    let paused = false;
    let programming = false;

    const stride = () => {
      const item = list.children[0];
      if (!item) return list.clientWidth || 1;

      const gap = Number.parseFloat(getComputedStyle(list).columnGap) || 0;

      return item.offsetWidth * 2 + gap * 2;
    };

    const pageCount = () => Math.ceil(list.children.length / 2);

    const currentPage = () => {
      const count = pageCount();
      if (count < 2) return 0;

      const next = Math.round(list.scrollLeft / stride());

      return Math.min(Math.max(next, 0), count - 1);
    };

    const paint = () => {
      if (!dots) return;

      for (const dot of dots.querySelectorAll('.erb-trust__dot')) {
        dot.setAttribute('aria-selected', Number(dot.dataset.page) === page ? 'true' : 'false');
      }
    };

    const stop = () => window.clearInterval(timer);

    const show = (next) => {
      const count = pageCount();
      if (count < 2) return;

      page = (next + count) % count;
      programming = true;
      list.scrollTo({
        left: page * stride(),
        behavior: this.prefersReducedMotion() ? 'auto' : 'smooth',
      });
      paint();
      window.setTimeout(() => {
        programming = false;
      }, 700);
    };

    const start = () => {
      stop();
      if (paused || !mobile.matches || this.prefersReducedMotion() || pageCount() < 2) return;

      timer = window.setInterval(() => show(page + 1), delay);
    };

    const pause = () => {
      paused = true;
      stop();
    };

    const resume = () => {
      paused = false;
      page = currentPage();
      start();
    };

    const onScroll = () => {
      if (programming) return;

      page = currentPage();
      paint();
    };

    const onClick = (event) => {
      const dot = event.target.closest('.erb-trust__dot');
      if (!dot || !dots?.contains(dot)) return;

      show(Number(dot.dataset.page));
      start();
    };

    const onChange = () => {
      page = 0;
      list.scrollLeft = 0;
      paint();
      start();
    };

    list.addEventListener('scroll', onScroll, { passive: true });
    list.addEventListener('pointerdown', pause);
    list.addEventListener('pointerup', resume);
    list.addEventListener('pointercancel', resume);

    if (canHover) {
      list.addEventListener('mouseenter', pause);
      list.addEventListener('mouseleave', resume);
    }
    dots?.addEventListener('click', onClick);
    mobile.addEventListener('change', onChange);
    paint();
    start();

    return () => {
      stop();
      list.removeEventListener('scroll', onScroll);
      list.removeEventListener('pointerdown', pause);
      list.removeEventListener('pointerup', resume);
      list.removeEventListener('pointercancel', resume);
      list.removeEventListener('mouseenter', pause);
      list.removeEventListener('mouseleave', resume);
      dots?.removeEventListener('click', onClick);
      mobile.removeEventListener('change', onChange);
    };
  },

  initPromises(root) {
    const list = root.querySelector('[data-erb-promises-list]');
    if (!list) return null;

    const mobile = window.matchMedia('(max-width: 749px)');
    const delay = 3200;
    let page = 0;
    let timer = 0;
    let paused = false;
    let programming = false;

    const stride = () => {
      const item = list.children[0];
      if (!item) return list.clientWidth || 1;

      const gap = Number.parseFloat(getComputedStyle(list).columnGap) || 0;

      return item.offsetWidth + gap;
    };

    const maxPage = () => Math.max(list.children.length - 2, 0);

    const stop = () => window.clearInterval(timer);

    const show = (next) => {
      const max = maxPage();
      if (max < 1) return;

      page = next > max ? 0 : next;
      programming = true;
      list.scrollTo({
        left: page * stride(),
        behavior: this.prefersReducedMotion() ? 'auto' : 'smooth',
      });
      window.setTimeout(() => {
        programming = false;
      }, 700);
    };

    const start = () => {
      stop();
      if (paused || !mobile.matches || this.prefersReducedMotion() || maxPage() < 1) return;

      timer = window.setInterval(() => show(page + 1), delay);
    };

    const pause = () => {
      paused = true;
      stop();
    };

    const resume = () => {
      paused = false;
      page = Math.min(Math.max(Math.round(list.scrollLeft / stride()), 0), maxPage());
      start();
    };

    const onScroll = () => {
      if (programming) return;

      page = Math.min(Math.max(Math.round(list.scrollLeft / stride()), 0), maxPage());
    };

    const onChange = () => {
      page = 0;
      list.scrollLeft = 0;
      start();
    };

    list.addEventListener('scroll', onScroll, { passive: true });
    list.addEventListener('pointerdown', pause);
    list.addEventListener('pointerup', resume);
    list.addEventListener('pointercancel', resume);
    mobile.addEventListener('change', onChange);
    start();

    return () => {
      stop();
      list.removeEventListener('scroll', onScroll);
      list.removeEventListener('pointerdown', pause);
      list.removeEventListener('pointerup', resume);
      list.removeEventListener('pointercancel', resume);
      mobile.removeEventListener('change', onChange);
    };
  },

  initPlans(root) {
    const scroller = root.querySelector('[data-erb-plan-scroll]');
    if (!scroller) return undefined;

    const desktop = window.matchMedia('(min-width: 990px)');
    let drag = null;

    const nearestCard = () => {
      const cards = [...scroller.querySelectorAll('.erb-circle__plan')];
      return cards.reduce((closest, card) => {
        const distance = Math.abs(card.offsetLeft - scroller.scrollLeft);
        if (!closest || distance < closest.distance) return { card, distance };
        return closest;
      }, null);
    };

    const onDown = (event) => {
      if (desktop.matches || event.pointerType === 'touch' || event.button !== 0) return;
      drag = {
        id: event.pointerId,
        x: event.clientX,
        left: scroller.scrollLeft,
        moved: false,
      };
    };

    const onMove = (event) => {
      if (!drag || event.pointerId !== drag.id) return;
      const dx = event.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) < 8) return;
      if (!drag.moved) {
        drag.moved = true;
        scroller.classList.add('is-dragging');
        scroller.setPointerCapture(event.pointerId);
      }
      scroller.scrollLeft = drag.left - dx;
    };

    const onUp = (event) => {
      if (!drag || event.pointerId !== drag.id) return;
      const moved = drag.moved;
      drag = null;
      scroller.classList.remove('is-dragging');
      if (!moved) return;

      const stopClick = (clickEvent) => {
        clickEvent.preventDefault();
        clickEvent.stopPropagation();
        scroller.removeEventListener('click', stopClick, true);
      };
      scroller.addEventListener('click', stopClick, true);

      const match = nearestCard();
      if (!match) return;
      scroller.scrollTo({ left: match.card.offsetLeft, behavior: 'smooth' });
    };

    scroller.addEventListener('pointerdown', onDown);
    scroller.addEventListener('pointermove', onMove);
    scroller.addEventListener('pointerup', onUp);
    scroller.addEventListener('pointercancel', onUp);

    return () => {
      scroller.removeEventListener('pointerdown', onDown);
      scroller.removeEventListener('pointermove', onMove);
      scroller.removeEventListener('pointerup', onUp);
      scroller.removeEventListener('pointercancel', onUp);
    };
  },

  initCollectionHeader(root) {
    const scroller = root.querySelector('[data-erb-pills-scroll]');
    if (!scroller) return undefined;

    const isDragEnabled = scroller.dataset.dragEnabled === 'true' || scroller.classList.contains('is-draggable');
    if (!isDragEnabled) return undefined;

    let drag = null;

    const onDragStart = (event) => {
      event.preventDefault();
    };

    const onPointerDown = (event) => {
      if (event.button !== 0) return;

      drag = {
        id: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        scrollLeft: scroller.scrollLeft,
        moved: false,
      };
    };

    const onPointerMove = (event) => {
      if (!drag || event.pointerId !== drag.id) return;

      const dx = event.clientX - drag.startX;
      const dy = event.clientY - drag.startY;

      if (!drag.moved && Math.abs(dx) < 6) return;

      if (!drag.moved && event.pointerType === 'touch' && Math.abs(dy) > Math.abs(dx)) {
        drag = null;
        return;
      }

      if (!drag.moved) {
        drag.moved = true;
        scroller.classList.add('is-dragging');
        try {
          scroller.setPointerCapture(event.pointerId);
        } catch (_) {}
      }

      scroller.scrollLeft = drag.scrollLeft - dx;
    };

    const onPointerUp = (event) => {
      if (!drag || event.pointerId !== drag.id) return;

      const moved = drag.moved;
      drag = null;
      scroller.classList.remove('is-dragging');

      if (moved) {
        const stopClick = (clickEvent) => {
          clickEvent.preventDefault();
          clickEvent.stopPropagation();
          scroller.removeEventListener('click', stopClick, true);
        };
        scroller.addEventListener('click', stopClick, true);
      }
    };

    scroller.addEventListener('dragstart', onDragStart);
    scroller.addEventListener('pointerdown', onPointerDown);
    scroller.addEventListener('pointermove', onPointerMove);
    scroller.addEventListener('pointerup', onPointerUp);
    scroller.addEventListener('pointercancel', onPointerUp);

    const activePill = scroller.querySelector('.erb-collection-header__pill--active');
    if (activePill) {
      requestAnimationFrame(() => {
        const scrollerRect = scroller.getBoundingClientRect();
        const pillRect = activePill.getBoundingClientRect();
        if (pillRect.left < scrollerRect.left || pillRect.right > scrollerRect.right) {
          const scrollTarget = activePill.offsetLeft - (scroller.clientWidth / 2) + (activePill.clientWidth / 2);
          scroller.scrollTo({ left: Math.max(0, scrollTarget), behavior: 'smooth' });
        }
      });
    }

    return () => {
      scroller.removeEventListener('dragstart', onDragStart);
      scroller.removeEventListener('pointerdown', onPointerDown);
      scroller.removeEventListener('pointermove', onPointerMove);
      scroller.removeEventListener('pointerup', onPointerUp);
      scroller.removeEventListener('pointercancel', onPointerUp);
    };
  },
};

window.ErbHome = ErbHome;

const erbStart = () => {
  document.querySelectorAll('[data-erb-root]').forEach((root) => ErbHome.boot(root));
  ErbHome.chrome();
};

const erbRootFromEvent = (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return null;
  if (target.matches('[data-erb-root]')) return target;
  return target.querySelector('[data-erb-root]');
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', erbStart);
} else {
  erbStart();
}

document.addEventListener('shopify:section:load', (event) => {
  const root = erbRootFromEvent(event);
  if (root) ErbHome.boot(root);
});

document.addEventListener('shopify:section:unload', (event) => {
  const root = erbRootFromEvent(event);
  if (root) ErbHome.destroy(root);
});
